export default {"src":"/_next/static/media/spiritory-logo.f51d93e8.svg","height":32,"width":188,"blurWidth":0,"blurHeight":0};